module.exports = __webpack_public_path__ + "5cdb56e570f868141df833e767813b01.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/carousel/qello/2.png
// module id = 849
// module chunks = 0